export const UTILITY_CHECKMARK_ICON = `<svg
                              viewBox="0 0 16 13"
                              fill="none"
                              aria-hidden="true"
                            >
                              <path
                                d="M1.5 7.5L5.21429 11.5L14.5 1.5"
                                stroke="currentColor"
                                stroke-width="3"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>`;
